import { FormControl, FormHelperText, Input } from '@material-ui/core'
import { Control, useController } from 'react-hook-form'
import { useFieldStyles } from './Field.style'
import { FieldProps } from './interfaces'

type SimpleTextFieldProps = {
  // eslint-disable-next-line
  control: Control | any
} & FieldProps

export const SimpleTextField = (props: SimpleTextFieldProps) => {
  const {
    control,
    name,
    defaultValue,
    label,
    rules = {},
    disabled,
    onEscPress,
  } = props
  const style = useFieldStyles()

  const {
    field,
    fieldState: { error },
  } = useController({ control, name, defaultValue, rules })

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      onEscPress && onEscPress(event)
      event.target.blur()
    }
  }

  return (
    <FormControl className={style.fieldBox} error={!!error?.message}>
      {label && <label className={style.fieldLabel}>{label}</label>}
      <Input
        {...field}
        disabled={disabled}
        value={field.value || ''}
        onKeyDown={onKeyDown}
      />
      <FormHelperText>{error?.message || ' '}</FormHelperText>
    </FormControl>
  )
}
